<template>
    <div class="cst-survey-answer cst-survey-answer-text">
        <textarea v-model.lazy="answerText"></textarea>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    export default {
      data: function () {
        return {
          answerText: '',
          currentAnswerText: ''
        }
      },
      props: ['question'],
      methods: {
        answer_question: function () {
          return new Promise((resolve, reject) => {
            if (this.answerText !== this.currentAnswerText) {
              eventHub.$emit('answer-question', { 'answerValue': 0, 'answerText': this.answerText, 'questionId': this.question.id }, false)
            }
            resolve()
          })
        }
      },
      created: function () {
        this.answerText = this.question.answer.answerText
        this.currentAnswerText = this.question.answer.answerText
        eventHub.$emit('pre-change-register', this.answer_question)
      },
      watch: {
        answerText: function () {
          this.question.answer.answerText = this.answerText
        }
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    textarea {
        .textarea
    }
</style>


// WEBPACK FOOTER //
// src/components/CardAnswerText.vue